module.exports = __webpack_public_path__ + "img/01 B_W-min.060c3de3.png";